import { useEffect, useState } from 'react';
import { Button, Column, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';

interface IInputReferralLinkProps {
  shortLink?: string;
  isLinkingSuccess: boolean;
  isLoading: boolean;
  onSubmit: (referralLink: string) => void;
  errorMessage?: string;
}

export const InputReferralLink = ({
  shortLink,
  isLinkingSuccess,
  isLoading,
  onSubmit,
  errorMessage,
}: IInputReferralLinkProps) => {
  const [referralLink, setReferralLink] = useState('');

  useEffect(() => {
    if (shortLink) {
      setReferralLink(shortLink);
    }
  }, [shortLink]);

  const handleSubmit = () => {
    onSubmit(referralLink);
  };

  return (
    <Column style={{ marginTop: 32 }}>
      {isLinkingSuccess && (
        <Column align="center" justify="center" gap={3} style={{ alignSelf: 'center' }}>
          <Typography as="span" size="body_large" bold color={colors.primary[500]}>
            Referral Link Submitted!
          </Typography>
          <Typography as="span" color={colors.neutral[500]}>
            Your friend’s referral link has been submitted successfully!
          </Typography>
        </Column>
      )}
      {!isLinkingSuccess && (
        <>
          <Typography
            as="span"
            bold
            color={colors.neutral[600]}
            size="body_large"
            style={{ marginBottom: 10, marginLeft: 2 }}
          >
            Enter and Submit Their Referral
          </Typography>
          <Column>
            <input
              className="input-field"
              style={{ margin: 0, width: '380px', borderRadius: 10 }}
              type="text"
              value={referralLink}
              onChange={(e) => setReferralLink(e.target.value)}
              placeholder="Enter Referral Link"
            />
            <Column style={{ height: 16, marginTop: 4, marginBottom: 32 }}>
              {errorMessage && (
                <Typography
                  as="span"
                  color={colors.error[500]}
                  size="caption"
                  style={{ marginLeft: 2 }}
                >
                  {errorMessage}
                </Typography>
              )}
            </Column>
          </Column>
          <Column align="center" justify="center" style={{ alignSelf: 'center' }}>
            <Button size="lg" onClick={handleSubmit} isLoading={isLoading} disabled={isLoading}>
              Submit Referral Link
            </Button>
          </Column>
        </>
      )}
    </Column>
  );
};
